import type { UnderlineOptions as TiptapUnderlineOptions } from '@tiptap/extension-underline'
import TiptapUnderline from '@tiptap/extension-underline'
import ActionButton from '@/notebook/components/ActionButton.vue'
import type { GeneralOptions } from '@/notebook/type'

export type UnderlineOptions = {} & TiptapUnderlineOptions & GeneralOptions<UnderlineOptions>

export const Underline = TiptapUnderline.extend<UnderlineOptions>({
  addOptions() {
    return {
      ...this.parent?.(),
      button({ editor, t }) {
        return {
          component: ActionButton,
          componentProps: {
            action: () => editor.commands.toggleUnderline(),
            isActive: () => editor.isActive('underline') || false,
            disabled: !editor.can().toggleUnderline(),
            icon: 'Underline',
            shortcutKeys: ['mod', 'U'],
            tooltip: t('editor.underline.tooltip'),
          },
        }
      },
    }
  },
})
